/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */
export const videos = [
  {
    _id: "cheYIVEtVQ4",
    catagory: "trailers",
    title: "Saviors Launch Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "When a monstrous beast attacks Storm Point, new Legend Newcastle leaps into the fray to protect and inspire his fellow Legends: because that’s what heroes are for. ",
    thumbnail: "https://i.postimg.cc/KvyQLNLf/maxresdefault.jpg",
    link: "https://youtube.com/embed/cheYIVEtVQ4",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "mUNYh_L250M",
    catagory: "trailers",
    title: "Defiance Launch Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2020 23:31:30",
    desc:
      "Mad Maggie might not be the hero the Legends want on their squad, but she might just be the villain they need. See if you can control the madness when Apex Legends: Defiance launches on February 8!",
    thumbnail: "https://i.postimg.cc/jjpK4mRC/maxresdefault.jpg",
    link: "https://youtube.com/embed/mUNYh_L250M",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "1R559DWBYbU",
    catagory: "trailers",
    title: "Escape Launch Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2021 23:31:30",
    desc:
      "The Legends are taking a vacation and they’re ready for some fun in the sun...or at least, they think they are. Plan your getaway when Apex Legends: Escape launches November 2.",
    thumbnail: "https://i.postimg.cc/rpB0RfbN/maxresdefault.jpg",
    link: "https://youtube.com/embed/1R559DWBYbU",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "oshvcDjEKZc",
    catagory: "trailers",
    title: "Legacy Launch Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2022 23:31:30",
    desc:
      "There’s nowhere to hide this season, Legends. Ready to find out if you’re predator or prey? Discover your true nature when Apex Legends – Legacy launches May 4!",
    thumbnail: "https://i.postimg.cc/qBnYKgts/maxresdefault.webp",
    link: "https://youtube.com/embed/oshvcDjEKZc",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "uQBKoZIYNrs",
    catagory: "trailers",
    title: "Emergence Launch Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "Change is constant in the Apex Games; are you watching closely? Pay attention or pay the price when Apex Legends: Emergence launches August 3.",
    thumbnail: "https://i.postimg.cc/BQdngm48/maxresdefault.webp",
    link: "https://youtube.com/embed/uQBKoZIYNrs",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "QzfsGxrCD4o",
    catagory: "trailers",
    title: "Assimilation Launch Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2020 23:31:30",
    desc:
      "Revenant used to be human. He was the greatest hitman the Mercenary Syndicate ever had. But when his programming eventually failed, he saw what Hammond Robotics had turned him into: a walking nightmare of steel and vestigial flesh. The return of Hammond Robotics to the Outlands ",
    thumbnail: "https://i.postimg.cc/sxL7K5gV/maxresdefault.webp",
    link: "https://youtube.com/embed/QzfsGxrCD4o",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "JZPbJ6VKs2E",
    catagory: "Outland Stories",
    title: "Stories from the Outlands - Judgment",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2021 23:31:30",
    desc:
      "It’s time for Mad Maggie to face justice for her crimes. But when you can’t be innocent and you won’t be guilty, what fate lies in store?",
    thumbnail: "https://i.postimg.cc/Vv0dfpz8/maxresdefault.jpg",
    link: "https://youtube.com/embed/JZPbJ6VKs2E",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "NKOVl6F8bjA",
    catagory: "Outland Stories",
    title: "Stories from the Outlands – Good as Gold",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2022 23:31:30",
    desc:
      "Some friends support your dreams, others have trouble letting go. Journey to Salvo and see if Fuse makes it to the Apex Games in one piece.",
    thumbnail: "https://i.postimg.cc/P5WKfFqY/maxresdefault.webp",
    link: "https://youtube.com/embed/NKOVl6F8bjA",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "JRRJQp2Bdwo",
    catagory: "Outland Stories",
    title: "Stories from the Outlands: Gridiron",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "Torn between her brother and the only cause she iss ever known, Bangalore has difficult decisions to make - and hard consequences to face - after the Battle of Gridiron.",
    thumbnail: "https://i.postimg.cc/Jhtq37qc/maxresdefault.jpg",
    link: "https://youtube.com/embed/JRRJQp2Bdwo",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "RY6j8RzpI5U",
    catagory: "Outland Stories",
    title: "Stories from the Outlands -Ashes to Ash",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "Ash’s problems are all in her head...but that is the most dangerous place they could be. Who is Ash, and who is Leigh?",
    thumbnail: "https://i.postimg.cc/qqY0Rvjb/maxresdefault.jpg",
    link: "https://youtube.com/embed/RY6j8RzpI5U",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "FTk9VD2nPuw",
    catagory: "Outland Stories",
    title: "Stories from the Outlands –Northstar",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2020 23:31:30",
    desc:
      "Valkyrie's been pulling smuggling jobs for years, but she didn't take this one for the money. Still, someone's got to pay...",
    thumbnail: "https://i.postimg.cc/Z5DTsj8t/maxresdefault.webp",
    link: "https://youtube.com/embed/FTk9VD2nPuw",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "gZVpiWUctLo",
    catagory: "Battle Pass",
    title: "Defiance Battle Pass",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2021 23:31:30",
    desc:
      "Buy the Defiance Battle Pass and battle through Daily and Weekly Challenges to earn unique rewards like Legendary sets for Seer and Loba, Epic sets for Ash, Crypto and Lifeline, reactive skins for the Hemlok and more! Or buy the Battle Pass Bundle to instantly unlock the first 25 levels and be the last one standing: in style!",
    thumbnail: "https://i.postimg.cc/8C8YC6Df/maxresdefault.jpg",
    link: "https://youtube.com/embed/gZVpiWUctLo",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "H_L6amOLQcg",
    catagory: "Battle Pass",
    title: "Escape Battle Pass",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2022 23:31:30",
    desc:
      "Buy the Escape Battle Pass and battle through Daily and Weekly Challenges to earn cosmetic sets for Mirage, Gibraltar, Wraith, Loba and Revenant, as well two Reactive Prowlers and dozens of other unique rewards!",
    thumbnail: "https://i.postimg.cc/3N71MXXY/maxresdefault.webp",
    link: "https://youtube.com/embed/H_L6amOLQcg",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "YVWGEacpe2k",
    catagory: "Battle Pass",
    title: "Emergence Battle Pass",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "Buy the Battle Pass and battle through Daily and Weekly Challenges to earn unique rewards like cosmetic sets for Seer, Valkyrie, and Horizon, XP Boosts, music packs and more!",
    thumbnail: "https://i.postimg.cc/26BhS2dn/maxresdefault.jpg",
    link: "https://youtube.com/embed/YVWGEacpe2k",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "WS18WGCUSng",
    catagory: "Battle Pass",
    title: "Season 6 –Battle Pass",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "Grab the Battle Pass and complete challenges to unlock Legendary items like Built for Speed Pathfinder, Road Warrior Bloodhound, and the Hypersonic reactive G7",
    thumbnail: "https://i.postimg.cc/xTFf6nVT/maxresdefault.webp",
    link: "https://youtube.com/embed/WS18WGCUSng",
    avatar:
      "https://besthqwallpapers.com/Uploads/29-11-2021/185838/thumb-apex-legends-violet-logo-4k-violet-neon-lights-creative-violet-abstract-background.jpg",
  },
  {
    _id: "3FPtT4C870c",
    catagory: "titanfall",
    title: "Titanfall - Launch Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc: "Check out the launch trailer for Titanfall.",
    thumbnail: "https://i.postimg.cc/tgc4rx3X/sddefault1-2.jpg",
    link: "https://www.youtube.com/embed/3FPtT4C870c",
    avatar:
      "https://media.pcgamesinsider.biz/2020/5/104967/respawn-logo-r225x.png",
  },
  {
    _id: "N1vqjJRcCzg",
    catagory: "titanfall",
    title: "Titanfall - Free The Frontier Trailer",
    creator: "Respawn Entertainment: Apex Legends",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "Watch the absolutely stunning Titanfall Frontier CGI trailer. It'll blow you away.",
    thumbnail: "https://i.postimg.cc/FKkVYrNf/maxresdefault.webp",
    link: "https://youtube.com/embed/N1vqjJRcCzg",
    avatar:
      "https://media.pcgamesinsider.biz/2020/5/104967/respawn-logo-r225x.png",
  },
  {
    _id: "hvECKXrAxPM",
    catagory: "other",
    title: "Respawn Entertainment 10th Anniversary Video",
    creator: "Electronics Arts: Respawn Entertainment",
    views: "100 views",
    publishedon: "03/03/2019 23:31:30",
    desc:
      "May 2020 marks the 10 year anniversary of Respawn Entertainment. Celebrate the legacy of the studio through the years, from their first title, Titanfall, in 2014 to the launch of Star Wars Jedi: Fallen Order in 2019 and beyond to Apex Legends’ continued live service content. The video also includes a small glimpse into what Respawn has coming next with the launch Medal of Honor: Above and Beyond (VR) later this year.",
    thumbnail: "https://i.postimg.cc/DZZFrMpb/maxresdefault.webp",
    link: "https://youtube.com/embed/hvECKXrAxPM",
    avatar:
      "https://moneyinc.com/wp-content/uploads/2018/07/Electronic-Arts-Logo.jpg",
  },
];
